<mat-expansion-panel
  #panel
  [attr.data-testid]="dataTestId()"
  class="mat-elevation-z0 expansion-panel"
  togglePosition="before">
  <mat-expansion-panel-header
    [attr.data-testid]="dropdownDataTestId()"
    [class.collapsed]="collapsed()"
    [class.org-admin]="orgAdmin()">
    @if (!collapsed()) {
      <mat-panel-title class="headline">
        <p class="clamp-text">{{ label() }}</p>
      </mat-panel-title>
    }
    <mat-panel-description class="description">
      <ng-content select=".extra-component"></ng-content>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
